import {IDataModel} from "../../services/IDataModel";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {IDataFilter} from "../../services/DataTable";
import * as _ from "lodash";
import {Observable} from "rxjs/Rx";
import {ResponseModel, ListResponseModel} from "../response/response.model";
import {Injectable} from "@angular/core";
import {
    DebtsModel, TimelineModel, AccountStatusesModel, SpeedDatesModel, TransactionModel,
    AddTransactionModel
} from './debts.model';

@Injectable()
export class DebtsService implements IDataModel {

    private API_ROOT:string = '/debts';

    public accountStatusTypes = {
        FUNDED: 1,
        OTHER: 0
    };


    constructor(private http:Http) {
    }

    getList(filter:IDataFilter): Observable<ListResponseModel<DebtsModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }
        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map(r => r.json());
    }

    getTimeline(debtId): Observable<ListResponseModel<TimelineModel>>  { // todo
        return this.http
            .get(`${this.API_ROOT}/${debtId}/timeline`)
            .map((res) => res.json());
    }

    getTimelineForStatements(debtId): Observable<ListResponseModel<TimelineModel>>  { // todo
        return this.http
            //.get(`${this.API_ROOT}/${debtId}/timeline/statements`)
            .get(`${this.API_ROOT}/${debtId}/timeline`)
            .map((res) => res.json());
    }


    getListByClient(clientId:number, filter?:IDataFilter): Observable<ListResponseModel<DebtsModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }

        return this.http
            .get(`/clients/${clientId}/debts`, new RequestOptions({
                search: params
            }))
            .map((res) => res.json());
    }

    getOneByClient(clientId:number):Observable<ResponseModel<DebtsModel>> {
        return this.http.get(`/clients/${clientId}/debts/active`).map((res) => res.json());
    }

    saveList(clientId:number, owners: DebtsModel[]): Observable<ListResponseModel<DebtsModel>> {
        return this.http.put(`/clients/${clientId}/debts`, owners)
            .map((res) => {
                let response: ListResponseModel<DebtsModel> = res.json();
                return response;
            });
    }

    getOne(id:number):Observable<ResponseModel<DebtsModel>> {
        return this.http.get(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

    add(fields:DebtsModel): Observable<ResponseModel<DebtsModel>>  {
        return this.http.post(this.API_ROOT, fields).map((res) => res.json());
    }

    edit(id:number, fields:DebtsModel): Observable<ResponseModel<DebtsModel>>  {
        return this.http.put(`${this.API_ROOT}/${id}`, fields).map((res) => res.json());
    }

    remove(id:number) {
        return this.http.delete(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }


    charge(id, fields:any): Observable<ResponseModel<DebtsModel>>  {
        return this.http.post(`${this.API_ROOT}/${id}/charge`, fields).map((res) => res.json());
    }


    voidPayment(paymentId, fields): Observable<ResponseModel<DebtsModel>>  {
        return this.http.post(`${this.API_ROOT}/payments/${paymentId}/void`, fields).map((res) => res.json());
    }

    voidLog(logId, fields): Observable<ResponseModel<DebtsModel>>  {
        return this.http.post(`${this.API_ROOT}/logs/${logId}/void`, fields).map((res) => res.json());
    }

    removeTimelineItem(logId, fields): Observable<ResponseModel<DebtsModel>>  {
        return this.http.post(`${this.API_ROOT}/timeline-item/${logId}/remove`, fields).map((res) => res.json());
    }

    updateStatementReason (table, id, fields) {
        return this.http.post(`${this.API_ROOT}/statements/${table}/${id}`, fields).map((res) => res.json());
    }

    processPendingTransactions (fields) {
        return this.http.post(`${this.API_ROOT}/process`, fields).map((res) => res.json());
    }

    applyTopup(debtId): Observable<ResponseModel<DebtsModel>>  {
        return this.http.post(`${this.API_ROOT}/${debtId}/apply-topup`, {}).map((res) => res.json());
    }

    getAccountStatuses(filter?:AccountStatusesModel): Observable<ListResponseModel<AccountStatusesModel>> {

        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }
        return this.http.get(`${this.API_ROOT}/statuses`, new RequestOptions({
            search: params
        })).map((res) => res.json());
    }

    addDebtStatus(fields:AccountStatusesModel): Observable<ResponseModel<AccountStatusesModel>> {
        return this.http.post(`${this.API_ROOT}/statuses`, fields).map((res) => res.json());
    }

    calculateSpeed(clientId, debtId, $dates:SpeedDatesModel): Observable<ResponseModel<any>> {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in $dates) {
            params.set(key, $dates[key]);
        }
        return this.http.get(`${this.API_ROOT}/${debtId}/client/${clientId}/speed`, new RequestOptions({
            search: params
        })).map((res) => res.json());
    }

    getQueue(): Observable<ResponseModel<any>> {
        return this.http.get(`/firstdata/queue`).map((res) => res.json());
    }

    sendQueue(): Observable<ResponseModel<any>> {
        return this.http.post(`/firstdata/queue`, []).map((res) => res.json());
    }

    deleteFromQueue(id: number): Observable<ResponseModel<any>> {
        return this.http.delete(`/firstdata/queue/${id}`, []).map((res) => res.json());
    }

    addTransaction(fields: AddTransactionModel): Observable<ResponseModel<TransactionModel>> {
        return this.http.post(`/transactions/add`, fields).map((res) => res.json());
    }

    closeAccount(debtId: number, fields): Observable<ResponseModel<any>> {
        return this.http.post(`${this.API_ROOT}/${debtId}/close`, fields).map((res) => res.json());
    }

    hideShowCharge(charge_id: number, hide: any): Observable<ResponseModel<any>> {
        return this.http
            .post('/debts/hide-show-charge', {charge_id: charge_id, hide: hide})
            .map((res) => res.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/models/debts/debts.service.ts